import React from 'react';
import Skeleton from "ubs-framework/v2/skeleton";
export const DocumentSkeleton = () => {
    return (
        <React.Fragment>
            <div className="u_h-full u_w-full">
                <div className="u_other-signature-heading ">
                    <Skeleton width="100%" height="80px" className=""/>
                </div>
                <div className="u_other-signature-body u_mt-15 ">
                    <Skeleton width="70%" height="100%" className="u_mx-auto u_other-signature-body-skeleton"/>
                </div>
            </div>
        </React.Fragment>
    );
};


export const NotAuthenticated = () => {
    return (
        <div className="u_error-page u_error-page-403">
            <div className="u_error-page-desc u_mb-30">
                <img src="/images/error_403.svg" alt="Access Forbidden"/>
                <h2>Access Forbidden</h2>
            </div>
        </div>
    );
};
